<template>
  <div :id="id" :title="texto" v-html="ayuda"></div>
</template>

<script lang="ts">
import { nanoid } from 'nanoid'
import {Vue, Component, Prop} from 'vue-property-decorator'

@Component
export default class TipoParrafo extends Vue {
  @Prop() id: string
  @Prop() texto: string
  @Prop({default: undefined}) value: string
  @Prop({default: ''}) ayuda: string

  get realId(): string {
    return this.id || 'parrafo-' + nanoid()
  }

  mounted() {
    this.$emit('input', undefined)
  }

}
</script>